<template>
  <div id="dashboard">
    <goal-overview v-if="isManager" />
    <personal-goal />
  </div>
</template>

<script>
import { some as _some } from 'lodash-es';
import GoalOverview from '../components/goal/GoalOverview.vue';
import PersonalGoal from '../components/goal/PersonalGoal.vue';
export default {
  name: 'GoalManagement',
  components: {
    GoalOverview,
    PersonalGoal,
  },
  computed: {
    currentUser() {
      return this.$auth.user();
    },
    roles() {
      return this.currentUser.roles;
    },
    isManager() {
      return (
        _some(this.roles, { name: 'specific-dealer-manager' }) ||
        _some(this.roles, { name: 'account-manager' })
      );
    },
  },
};
</script>
